import { ReactComponent as ArrowUpCircle } from '@/assets/svgs/arrow-up-circle.svg';
import Button from "@/components/Button/index";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import rem from '@/utils/rem';
import { Checkbox } from '@dextech-ai/dex-design-system';
import { useEffect, useState } from 'react';

const AgentPrincipalTnCModal = ({ visible, hide, acceptParticipantTnc, onCancel, onAccept, loading }) => {

	const [checkedParticipantsTncModal, setCheckedParticipantsTncModal] = useState(false)

	useEffect(() => {
		if (!visible) {
			setCheckedParticipantsTncModal(false)
		}
	}, [visible])

	function handledCheckedParticipantTnc() {
		setCheckedParticipantsTncModal(!checkedParticipantsTncModal)
	}

	return (
		<Modal visible={visible} variant='large' close={hide } dismissClickOutsideModal={false}>
			<CardConfigure addHeaderClass="eap-modal__header" >
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__rounded-square'}>
										<div className='tnc-modal__icon'><ArrowUpCircle /></div>
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Terms and Conditions for Agent-Principal Functionality
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div>
							<div className="eap-modal__content">
								<p>
									The feature enables your pitstop to act as an intermediary for your Principals (users), managing their data access requirements. As an Agent, your role involves ensuring that data access and management align with the needs and expectations of your Principals.
								</p>
								<br />
								<p>
									By accessing or using this functionality, you confirm that you are authorised to share or receive Shared Data on behalf of the Principal. You further acknowledge and agree that any sharing or receipt of Shared Data shall comply with applicable laws.
								</p>
								<br />
								<p>
									You shall only use the Shared Data for the specific purpose for which it was provided by your Principal. Any other use requires explicit consent from the Principal or as permitted by applicable laws.
								</p>
								<br />
								<p>
									You shall be solely responsible for any misuse or unauthorised sharing or receipt of Shared Data, and agree to indemnify and hold harmless the Company from and against any loss or claim suffered by the Company arising out of or in connection with this service.
								</p>
							</div>
							<div className="tnc-modal__agree-content">
								<Checkbox
									checked={checkedParticipantsTncModal}
									onCheckedChange={handledCheckedParticipantTnc}
									data-testid="agent-principal-tnc-checkbox"
								>
									I have read and accepted the T&Cs
								</Checkbox>
							</div>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<div className='tnc-modal__confirmation_actions'>
							<Button data-testid="agent-principal-tnc-decline" ghost round addClass="eap-modal__transButton" submit={() => hide()} text="Decline" />
							<Button data-testid="agent-principal-tnc-agree" full round maxWidth="100" submit={() => acceptParticipantTnc()} disabled={!checkedParticipantsTncModal} text="Agree" />
						</div>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
};

export default AgentPrincipalTnCModal;
